














































import Vue from "vue";
import Component from "vue-class-component";
import { Emit } from "vue-property-decorator";
import { nextMonth } from "@/types";
import TextMonthChangePicker from "@/components/common/TextMonthChangePicker.vue";

export interface CsvOutputItem {
  targetYM: string; //請求月
}

@Component({
  components: {
    TextMonthChangePicker
  }
})
export default class OutputCsvDialog extends Vue {
  private item: CsvOutputItem = {
    targetYM: nextMonth()
  };

  //開いているかどうか
  private isActive = false;

  //開く
  public open() {
    this.isActive = true;
  }

  //プレビュー
  @Emit()
  private csv() {
    this.isActive = false;
    return this.item;
  }

  //キャンセル
  private cancel() {
    this.isActive = false;
  }

  //faqへ飛ばす
  private goFaq() {
    window.open(
      process.env.VUE_APP_IBOW_FRONTEND_URL + "/contact/faq/show/4406"
    );
  }
}
